module.exports = __webpack_public_path__ + "img/1.bde017bf.png";